// @noflow
import segmentTrack from '@/components/analytics/Analytics'
import type { CookiePreferences } from '@/components/cookie_consent/index'
import { Variant } from '@/components/shared/CookieConsent/Modals/CookieConsentModal'
import { Action } from '@/components/shared/CookieConsent/types'
import type { LocalStorageCookieConsent } from '@/components/shared/CookieConsent/types'

const cookieConsentLocalStorageKey = 'cookieConsent'

enum Context {
  Close = 'Close',
  GotIt = 'Got It',
  AcceptAll = 'Accept All',
  SaveChanges = 'Save Changes',
  Scrolled = 'Scrolled'
}

enum Component {
  Banner = 'Banner',
  Modal = 'Modal',
  Null = 'Null'
}

type Props = LocalStorageCookieConsent & {
  applyPreferences?: (preferences: CookiePreferences) => void
}

type CookieAnalyticsProps = {
  preferences: CookiePreferences
  variant: Variant
  component: Component
  context: Context
}

const actionToCookieConsent = ({
  action,
  preferences,
  applyPreferences
}: Props): void => {
  switch (action) {
    case Action.Accepted: {
      if (applyPreferences) {
        applyPreferences({ marketing: true, analytics: true })
      }

      localStorage.setItem(
        cookieConsentLocalStorageKey,
        JSON.stringify({
          state: 'accepted',
          preferences: { marketing: true, analytics: true }
        })
      )

      break
    }
    case Action.None: {
      localStorage.setItem(cookieConsentLocalStorageKey, 'null')
      break
    }
    case Action.Cancelled: {
      break
    }
    case Action.Saved: {
      if (applyPreferences && preferences) {
        applyPreferences(preferences)
      }
      localStorage.setItem(
        cookieConsentLocalStorageKey,
        JSON.stringify({
          state: 'accepted',
          preferences
        })
      )
      break
    }
    case Action.Deny: {
      if (applyPreferences) {
        applyPreferences({ marketing: false, analytics: false })
      }
      localStorage.setItem(
        cookieConsentLocalStorageKey,
        JSON.stringify({
          state: 'accepted',
          preferences: { marketing: false, analytics: false }
        })
      )
    }
  }
}

const trackCookiePreferences = ({
  preferences,
  variant,
  component,
  context
}: CookieAnalyticsProps): void => {
  segmentTrack('Cookie Preferences Saved', {
    preferences,
    variant,
    component,
    context
  })
}

const manageCookiesClicked = (): void => {
  segmentTrack('Manage Cookies Clicked')
}

export {
  actionToCookieConsent,
  trackCookiePreferences,
  manageCookiesClicked,
  Context,
  Component
}
